import React from "react";

import { InstitutionalTextPage } from "../../components/InstitutionalTextPage";
import { HOUSING_PROGRAM_INFO_PAGE } from "../../content/housingProgramInfo";
import HousingProgramGuide from "./HousingProgramGuide";

export default function HousingProgramInfo() {
  return (
    <InstitutionalTextPage {...HOUSING_PROGRAM_INFO_PAGE}>
      <HousingProgramGuide />
    </InstitutionalTextPage>
  );
}
